import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from './AuthContext';

const DEFAULTS = {
  platform_name: 'Dal Sud',
  tagline: null,
  logo_url: null,
  favicon_url: null,
};

const SiteContext = createContext(DEFAULTS);

export const SiteProvider = ({ children }) => {
  const [identity, setIdentity] = useState(DEFAULTS);

  useEffect(() => {
    api.get('/cms/identity')
      .then(res => {
        const data = { ...DEFAULTS, ...res.data };
        setIdentity(data);

        // Aggiorna favicon dinamicamente se impostato
        if (data.favicon_url) {
          let link = document.querySelector("link[rel~='icon']");
          if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
          }
          link.href = data.favicon_url;
        }
      })
      .catch(() => {
        // Nessun impatto se fallisce — si usano i default
      });
  }, []);

  return (
    <SiteContext.Provider value={identity}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
